<template>
  <div class="about">
    <div style="margin-bottom: 20px;">
      <el-button
        @click="addTab"
        type="primary"
      >
        添 加
      </el-button>
    </div>
    <el-tabs v-model="value" editable type="card" @edit="handleTabsEdit">
      <el-tab-pane v-for="(item,index) in content" :label="item.left_title" :name="''+index" :key="index">
        <el-form ref="form" label-width="80px" class="tab-form">
          <el-form-item label="左侧标题">
            <el-input v-model="item.left_title"></el-input>
          </el-form-item>
          <el-form-item label="左侧标题(英文)">
            <el-input v-model="item.left_title_en"></el-input>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="item.title"></el-input>
          </el-form-item>
          <el-form-item label="标题(英文)">
            <el-input v-model="item.title_en"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <VueUEditor
              ueditorPath="/static/q_ueditor/"
              @ready="editorReady($event, item)">
            </VueUEditor>
          </el-form-item>
          <el-form-item label="内容(英文)">
            <VueUEditor
              ueditorPath="/static/q_ueditor/"
              @ready="editorReadyEn($event, item)">
            </VueUEditor>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-row class="btn-g">
      <el-button type="primary" @click="submit">保 存</el-button>
    </el-row>
  </div>
</template>
<script>
import request from '@/utils/request'
import VueUEditor from 'vue-ueditor'
export default {
  name: 'about',
  components: {
    VueUEditor
  },
  data () {
    return {
      value: '0',
      content: []
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      request({
        url: '/ui/movie/about-page'
      }).then(res => {
        this.content = res.data.content || []
      })
    },
    editorReady (editor, item) {
      editor.setContent(item.html || '')
      editor.addListener('contentChange', _ => {
        item.html = editor.getContent()
      })
    },
    editorReadyEn (editor, item) {
      editor.setContent(item.html_en || '')
      editor.addListener('contentChange', _ => {
        item.html_en = editor.getContent()
      })
    },
    handleTabsEdit(e) {
      this.content.splice(e, 1);
    },
    addTab () {
      let tab = {
        left_title: 'newTab' + (this.content.length + 1),
        title: '标题',
        html: ''
      }
      this.content.push(tab)
      this.value = '' + (this.content.length - 1)
    },
    submit () {
      request({
        url: '/ui/movie/about-page',
        method: 'put',
        data: {
          content: this.content
        }
      }).then(res => {
        this.$message.success('保存成功!')
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-form-item {
  margin-bottom: 10px!important;
}
.tab-form {
  width: 700px;
}
.form {
  width: 650px;
}
.btn-g {
  margin-top: 25px;
}
.time-line {
  padding: 15px 0 10px 0;
  width: 650px;
  position: relative;
  border-bottom: 1px dashed #DCDFE6;
  .icon {
    position: absolute;
    top: 15px;
    right: 0;
    font-size: 20px;
    i {
      margin-left: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/setting/about.vue